module.exports = __webpack_public_path__ + "static/hoppys-3-034f0b81cab62cfb91876d37276d7a66.jpg";